// This is due to test and the inability to mock or stub __dirname
export default () => __dirname
